import { AuthSessionStatus } from "@sellar-io/common";
import type {
  AuthSessionRequestType,
  AuthSessionResponseType,
} from "@sellar-io/api-v2/types";
import type { ExtendedFirebaseUser } from "../../../useFirebaseUser.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";

export const fetchAuthSession = async ({
  user,
  ...data
}: AuthSessionRequestType & {
  user: ExtendedFirebaseUser;
}): Promise<AuthSessionResponseType> => {
  const response = await apiV2Request({
    user,
    business: null,
    method: "post",
    path: "auth/session",
    data,
    timeout: 15000,
  });
  const result = apiV2AssertResponse<AuthSessionResponseType>(response).data;
  if (
    !result ||
    !Object.values(AuthSessionStatus).includes(result.status) ||
    (result.status !== AuthSessionStatus.NeedsProfile && !result.user) ||
    (result.status === AuthSessionStatus.Ready && !result.business)
  ) {
    throw new Error("Invalid session response");
  }
  return result;
};
